import React from 'react';

const Button = ({
  children,
  type = 'button',
  onClick,
  className = '',
  disabled = false,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`th-btn ${className}`}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
